import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRIMARY_CTA } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const easeOut = [0.23, 1, 0.32, 1] as const;
const heroReassurance = ['Immediate Digital Access', 'One-Time Payment', '7-Day Guarantee'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-white" data-id="element-151" data-mp="12862k3i3uktp">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-152" data-mp="xbfmhg6avp8a">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOut
      }} className="w-full" data-id="element-153" data-mp="sart4nulmwaw">
          <div className="inline-block px-3 py-1 rounded-full border border-[#B8C4CE] bg-[#0B2545] text-white font-bold text-[10px] sm:text-sm tracking-widest mb-4 sm:mb-6" data-id="element-154" data-mp="3d21ty23jwspu">
            NURSING INSTRUCTOR <span className="text-[#7FD6D1]" data-id="element-155" data-mp="3j7zg1kyg9whq">ATLAS</span>
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight mb-4 sm:mb-6 text-[#0B2545] uppercase" data-id="element-156" data-mp="3j6oe7qokeyt9">
            Solve <span className="text-[#0A7D79]" data-id="element-157" data-mp="399jq3lb5st9t">Months of Nursing Class Planning</span>{' '}
            <span className="bg-[#0B2545] text-white px-2 box-decoration-clone" data-id="element-158" data-mp="3e8ecsyc8z1z7">in Just 5 Minutes!</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: easeOut
      }} className="relative w-full max-w-[360px] sm:max-w-xl md:max-w-2xl mb-4 sm:mb-6" data-id="element-159" data-mp="30fybq32wpe0x">
          <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="relative z-10 w-full h-auto drop-shadow-xl" data-id="element-160" data-mp="2vj7u3bbgeade" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: easeOut
      }} className="w-full" data-id="element-161" data-mp="2ljgxn43c1lao">
          <p className="text-sm sm:text-lg md:text-xl text-slate-700 leading-snug max-w-3xl mx-auto mb-1 sm:mb-2" data-id="element-162" data-mp="n9qira2x6u7y">
            The Complete{' '}
            <span className="font-semibold text-[#025B57]" data-id="element-163" data-mp="dd59gcjvawyb">
              6-IN-1 Visual Nursing Education &amp; Clinical Training System for Nursing Instructors, Clinical Faculty &amp; Nurse Educators.
            </span>
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-164" data-mp="162ugp7n67t8d">
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10" data-id="element-165" data-mp="112pzffefuuh3">
              {PRIMARY_CTA}
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-slate-700/80 mb-3" data-id="element-166" data-mp="3lui8ypr8oxku">
            {heroReassurance.map(item => <div key={item} className="flex items-center gap-1.5" data-id="element-167" data-mp="1xa42nb9pqei1">
                <CheckCircle size={14} className="text-[#0A7D79]" data-id="element-168" data-mp="21awca5mhyleu" />
                <span className="font-medium" data-id="element-169" data-mp="21b647yr3r2n6">{item}</span>
              </div>)}
          </div>

          <p className="text-sm sm:text-lg md:text-xl text-slate-700 leading-snug max-w-3xl mx-auto mb-3 sm:mb-4" data-id="element-170" data-mp="267wiqhn9dq6h">
            <span className="font-semibold text-[#0B2545]" data-id="element-171" data-mp="2b2k6geafugk0">6 Professional Visual Training Volumes</span> + 5
            Exclusive Bonuses — everything organized to help you plan, explain, demonstrate and assess every
            nursing class, skills lab, simulation and clinical rotation, from fundamentals and health assessment to nursing procedures, pharmacology, dosage calculations, med-surg and emergency care, from beginner to advanced, with more clarity, structure and confidence.
          </p>

          <p className="text-xs sm:text-sm font-bold tracking-widest text-[#025B57] mb-5 sm:mb-7" data-id="element-172" data-mp="zlkjly6v0txd">
            FROM NURSING FUNDAMENTALS &amp; ASSESSMENT TO CLINICAL PROCEDURES, EMERGENCY CARE &amp; TEACHING METHODS
          </p>

          <p className="text-xs text-slate-500" data-id="element-173" data-mp="3vignm664gdyb">
            6 VISUAL VOLUMES · 300 TRAINING PAGES · 5 EXCLUSIVE BONUSES
          </p>
        </motion.div>
      </div>
    </section>;
}